<script setup lang="ts">
import { ElInput } from "element-plus";
import { ref, watch } from "vue";
import { useDebounceFn } from "@vueuse/core";

export interface Props {
  debounceTime?: number;
  modelValue?: string;
  placeholder: string;
}
const props = withDefaults(defineProps<Props>(), {
  debounceTime: 500,
});

const input = ref<string>();
watch(
  () => props.modelValue,
  () => (input.value = props.modelValue),
  { immediate: true }
);

const emit = defineEmits<{
  (e: "update:model-value", query: string): void;
}>();

const onInput = useDebounceFn((query: string) => {
  emit("update:model-value", query);
}, props.debounceTime);
</script>

<template>
  <el-input
    v-model="input"
    class="search"
    :placeholder="placeholder"
    clearable
    @input="onInput"
  >
    <template #prefix>
      <font-awesome-icon :icon="['fal', 'magnifying-glass']" />
    </template>
  </el-input>
</template>

<style scoped lang="scss">
.search {
  display: flex;
  @media screen and (min-width: $breakpoint-lg) {
    max-width: 300px;
  }
}
</style>
